// CSRF token holder. Populated by the auth bootstrap (call /auth/me on
// app load), read by the Apollo csrfLink for every mutation. We keep
// the value in module state rather than React context because Apollo's
// link factory runs once at module load - it can't subscribe to a
// React provider.

let token: string | null = null;

export function setCsrfToken(value: string | null): void {
  token = value;
}

export function csrfToken(): string | null {
  return token;
}
